import React from 'react';
import Select from 'react-select';
import IndefiniteProgressbar from "../IndefiniteProgressbar.mjs";

class SelectAD extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = { ads: false, aa: opts.aa, ente: opts.ente };
		this.loadAD.bind(this);
		this.ad2options.bind(this);
		this.onchange.bind(this);
		this.uid = "SelectAD-"+window.glob.generateUid();
	};
	componentDidMount() {
		if ( this.props.globPrefix && this.props.deps ) {
			if ( this.props.deps.ente ) {
				window.glob.register(this.props.globPrefix+'changed.'+this.props.deps.ente,(e)=> {
					this.setState({ ente: e, aa:false, ads: false });
				}, this.uid );
			}
			if ( this.props.deps.aa ) {
				window.glob.register(this.props.globPrefix+'changed.'+this.props.deps.aa,(a)=> {
					if ( this.state.ads || (this.state.aa !== a )) this.setState({ aa: a, ads: false });
				}, this.uid );
			}
		}
	};
	componentWillUnmount() {
		if ( this.props.globPrefix && this.props.deps ) {
			window.glob.unregister([
				this.props.globPrefix+'changed.'+this.props.deps.ente,
				this.props.globPrefix+'changed.'+this.props.deps.aa
			],this.uid );
		}
	};
	loadAD() {
		window.glob.api(
			'lsAds',
			{ lente: this.state.ente.lente, laa: this.state.aa }
		).then( (e)=>{
			this.ad2options(e);
		})
	};
	ad2options(el) {
		let e = el.map( i => {
			const i2= JSON.parse(JSON.stringify(i));
			delete i2.ldocente;
			return {
				label : `${i.ldocente}: «${i.lnome}» (${i.lannocorso}${ i.lcanale ? ', '+i.lcanale : ''})`,
				value: JSON.stringify(i2)
			};
		});
		e = e.sort( (a,b)=>{ return a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1  });
		this.setState({ ads: e });
	}
	onchange(o) {
		if ( this.props.globPrefix ) {
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{name:this.props.name, value: JSON.parse(o.value)}
			);
		}
	}
	render() {
		if ( ! this.state.aa ) {
			return <p className={"comment"}>↳ Scegli prima l’Anno Accademico.</p>;
		}
		if ( ! this.state.ads ) {
			setTimeout( ()=> { this.loadAD() }, 100);
			return <p className={"comment"}><IndefiniteProgressbar /></p>;
		}
		return (
			<Select
				id={this.uid}
				options={this.state.ads}
				className={"w-100"}
				autoFocus={true}
				onChange={(v)=> { this.onchange(v) }}
			/>
		);
	}
}

export default SelectAD;